export default {"src":"https://wp-static.smartkarma.com/_next/static/media/user-chart-white.17632aed.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};